import VCFunds from "./VCFunds";

export default VCFunds;
